import styled from 'styled-components';

export const Container = styled.div`
  height: 70px;
  width: 100%;
  padding: 0 20%;
  background: var(--white);
  border-bottom: 1px solid var(--gray-e);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 9;

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 800px) {
    padding: 0 24px;
  }
`;

export const Button = styled.button`
  background: transparent;
  outline: none;
  height: 30px;
  cursor: pointer;

  color: var(--gray-9);
`;

export const Title = styled.p`
  font-size: 18px;
  color: var(--black-5);
  font-weight: 600;
  margin-left: 24px;
`;

export const OfflineBar = styled.div`
  height: 30px;
  width: 100%;
  background: var(--black-transparent);
  backdrop-filter: blur(20px);
  color: var(--white);
  font-size: 14px;
  position: fixed;
  z-index: 9;
  top: 70px;

  display: flex;
  justify-content: center;
  align-items: center;
`;
